import { render } from "./SupportCard.vue?vue&type=template&id=d37df746&scoped=true"
import script from "./SupportCard.vue?vue&type=script&lang=js"
export * from "./SupportCard.vue?vue&type=script&lang=js"

import "./SupportCard.vue?vue&type=style&index=0&id=d37df746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37df746"]])

export default __exports__